import { topicItems } from '@/mocks/home';

export default function SectionTopics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 mx-auto max-w-7xl">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-sm font-medium text-primary-600 mb-2">社区热议</p>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">热门话题</h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-lg mx-auto">加入热门影视话题讨论，与千万影迷一起畅聊</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {topicItems.map((item) => {
            const trendIcon = item.trend === 'hot' ? 'ri-fire-line' : item.trend === 'rising' ? 'ri-funds-line' : 'ri-flashlight-line';
            const trendColor = item.trend === 'hot' ? 'text-accent-600' : item.trend === 'rising' ? 'text-primary-600' : 'text-secondary-600';
            const trendBg = item.trend === 'hot' ? 'bg-accent-100' : item.trend === 'rising' ? 'bg-primary-100' : 'bg-secondary-100';
            return (
              <a
                key={item.id}
                href="#comments"
                onClick={(e) => { e.preventDefault(); document.querySelector('#comments')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="flex items-center gap-3 md:gap-4 bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer group"
              >
                <div className={`w-10 h-10 rounded-lg ${trendBg} flex items-center justify-center flex-shrink-0`}>
                  <i className={`${trendIcon} ${trendColor} text-lg`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 truncate">
                    {item.title}
                  </div>
                  <div className="flex items-center gap-2 mt-1">
                    <span className="text-xs text-foreground-500">{item.category}</span>
                    <span className="text-xs text-foreground-300">·</span>
                    <span className="text-xs text-foreground-500">{item.posts} 讨论</span>
                  </div>
                </div>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 ${trendColor}`}>
                  <i className={`${trendIcon} text-sm`}></i>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}